module.exports={
    logout  : "Quitter la connexion",
    my      :'Mon',
    scqx    :'Autorisations supprimées',
    qxgl    :'Gestion des droits',
    qdzxzhm :'Vous  êtes sûr de vous déconnecter de votre compte?',
    qtxkh   :'Veuillez remplir le numéro de carte',
    qd      :'Confirmer',
    qx      :'Annuler',
    gb      :'Fermer',
    kh      :'Numéro de carte',
    kmewm   :'Code QR douverture de porte',
    dl      :'Se connecter',
    name    :'Nom de lutilisateur',
    qtxname :'Veuillez remplir le nom dutilisateur',
    pwas    :'Mot de passe',
    qtxpwas :'Veuillez remplir le mot de passe',
    tj      :'Soumettre',
    zczh    :'Numéro de compte enregistré',
    zc      :'Enregistrer',
    sjhm    :'Numéro de téléphone',
    qtxsjhm :'Veuillez remplir votre numéro de téléphone',
    yzm     :'Code du SMS',
    qtxyzm  :'Veuillez remplir le code de vérification',
    yyzhqqdl:'Vous avez déjà un compte, allez vous connecter',
    hqyzm   :'Obtenir le Code de vérification',
    zccg    :'Enregistrement réussie',
    zcsb    :'Échec de l’enregistrement',
    fscg    :'Envoi réussi',
    fssb    :'Échec d’envoi',
    yhycz   :'L’utilisateur existe déjà',


    xgmm    : "Modification des mots de passe",
    zhmm    :'Récupérer le mot de passe',
    qrmm    :'Confirmer le mot de passe',
    zhyxmm  :"Récupérer la boîte aux lettres du mot de passe",
    yxyzm   :'Code d’authentification de la boîte aux lettres',
    hqyxyzm :'Obtenir le Code de vérification de la boîte aux lettres',
    zzmmyx  :'Réinitialiser la boîte aux lettres de mot de passe',
    lcmmbyc :'Les deux codes ne correspondent pas.',
    xgcg    :'Modification réussie',
    xgsb    :'Échec de la modification',
    qtxyxyx  :'Veuillez remplir une boîte aux lettres valide',
    lsmhhq  :'Récupérer dans 60 secondes',
    hqyyyzmcg:'Obtenir le Code de vérification de la boîte aux lettres avec succès',
    zhmmbd  :'Mot de passe de compte incorrect'
}